import { cn } from '@repo/tailwind-config/tailwind.functions'

import Typography from './typography'

type TextInformationProps = {
  title: string | React.ReactNode
  className?: string
  value?: string
  component?: React.ReactNode
}

const TextInformation: React.FC<TextInformationProps> = ({
  title,
  className,
  value,
  component
}) => {
  return (
    <div className={cn('flex flex-col gap-1 items-start', className)}>
      <Typography variant="label-medium" className="text-grey-lighter">
        {title}
      </Typography>
      {value && <Typography variant="tag">{value}</Typography>}
      {component}
    </div>
  )
}

export default TextInformation
